import { OptionDto } from "@/dtos";
import { RechargerTransactionStatus } from "@/helpers/types";

const rechargerTransactionStatus = [
    { value: RechargerTransactionStatus.PENDIENT, label: 'Pendiente' },
    { value: RechargerTransactionStatus.READY, label: 'Listo' },
] as OptionDto[];

export const getRechargerTransactionStatusOptions = (): OptionDto[] => {
    return rechargerTransactionStatus;
}

export const getRechargerTransactionStatusOption = (value?: number): OptionDto => {
    return rechargerTransactionStatus.find((x) => x.value == value) ?? rechargerTransactionStatus[0];
}

export const getRechargerTransactionStatusLabel = (value: number): string => {
    return rechargerTransactionStatus.find((x) => x.value == value)?.label ?? rechargerTransactionStatus[0].label;
}